import { f7 } from "framework7-vue";

var PAGES = {
  // guest
  LOGIN_PAGE: "/login",
  MAIN_PAGE: "/",
  CONFIG_PAGE: "/config",
  PROGRAM_INFO_PAGE: "/program-info",
  LICENSE_INFO_PAGE: "/license-info",
  USER_INFO_PAGE: "/user-info",
  REGIST_PAGE: "/regist",
  PARENT_AGREE_PAGE: "/parent_agree",
  PARENT_REGIST_PAGE: "/parent_regist",
  SELECT_REGIST_PAGE: "/select_regist",
  IDPW_PAGE: "/idpw",
  INDI_INFO_PAGE: "/indi-info",
  USE_INFO_PAGE: "/use-info",
  MENU_GUEST_DIAG_MAIN_PAGE: "/pwa/all_guest/diag/diag_main",
  MENU_GUEST_PQAT_MAIN_PAGE: "/pwa/all_guest/pqat/pqat_main",

  // all user
  EDIT_STUDENT_PAGE: "/pwa/all_user/user/edit-student",
  EDIT_TEACHER_PAGE: "/pwa/all_user/user/edit-teacher",

  //campus 원장
  MENU_CGL_DASH_BOARD:"/pwa/campgnrl_leader/manage/dashboard",
  SUB_CGL_STUDY_DETAIL: "/pwa/campgnrl_leader/manage/study/study-detail-info",
  SUB_CGL_PAY_DETAIL: "/pwa/campgnrl_leader/manage/pay/pay-detail-info",

  // myroom
  MENU_CCM_COURSE_LIST: "/pwa/campclass_member/myroom/course_list",
  SUB_CCM_COURSE_DASHBOARD: "/pwa/campclass_member/myroom/course_dashboard",
  MENU_CCM_HOMEWORK_LIST: "/pwa/campclass_member/study/homework",
  MENU_CCM_POINT_LIST: "/pwa/campclass_member/myroom/points",

  //planner
  MENU_CCM_STUDY_PLAN_DAY: "/pwa/campclass_member/study_planner/study_plan_day",
  MENU_CCM_STUDY_PLAN_WEEK:
    "/pwa/campclass_member/study_planner/study_plan_week",
  MENU_CCM_STUDY_PLAN_MONTH:
    "/pwa/campclass_member/study_planner/study_plan_month",
  SUB_CCM_STUDY_PLAN_REVIEW_APPLY:
    "/pwa/campclass_member/study_planner/review_apply",
  SUB_CCM_STUDY_PLAN_UNIT_APPLY:
    "/pwa/campclass_member/study_planner/unit_apply",
  SUB_CCM_STUDY_PLAN_CLINIC_APPLY:
    "/pwa/campclass_member/study_planner/clinic_apply",

  // study
  MENU_CCM_CODE_STUDY: "/pwa/campclass_member/study/code_study",
  MENU_CCM_CODE_APPLY: "/pwa/campclass_member/study/code_apply",
  SUB_CCM_EXAMSET_APPLY: "/pwa/campclass_member/study/examset_apply",
  SUB_CCM_MATCHPAPER_APPLY: "/pwa/camclass_member/study/matchpaper_apply",
  SUB_CCM_MATCHBOOK_APPLY: "/pwa/camclass_member/study/matchbook_apply",
  MENU_CCM_CLINIC_STUDY: "/pwa/campclass_member/study/clinic",
  SUB_CCM_CLINIC_APPLY: "/pwa/campclass_member/study/clinic_apply",
  MENU_CCM_PAT_CONQUER_STUDY: "/pwa/campclass_member/study/pat",
  SUB_CCM_PAT_CONQUER_APPLY: "/pwa/campclass_member/study/pat_apply",
  MENU_CCM_MATCHBOOK_STUDY: "/pwa/campclass_member/study/matchbook",
  SUB_CCM_MATCHBOOK_ADD_EXAM: "/pwa/campclass_member/study/matchbook_add_exam",
  MENU_CCM_MATCHPAPER_STUDY: "/pwa/campclass_member/study/matchpaper",
  MENU_CCM_SMARTBOOK_STUDY: "/pwa/campclass_member/study/smartbook",
  MENU_CCM_SELF_STUDY: "/pwa/campclass_member/study/self_study",

  CGM_DASHBOARD: "/pwa/campgnrl_member/main/dashboard",
  CGM_WEEKSTUDY: "/pwa/campgnrl_member/main/week_study",
  CGM_WEEKDANGER: "/pwa/campgnrl_member/main/week_danger",
  CGM_WEEKACTIVITY: "/pwa/campgnrl_member/main/week_activity",

  NOTICE_LIST: "/pwa/all_user/cs/notice",
  MENU_CONTENTS_REPORT_LIST: "/pwa/all_user/cs/report_list",
  SUB_CONTENTS_REPORT: "/pwa/all_user/cs/contents_report",

  //parent
  MENU_PAYMENT_LIST: "/pwa/campparent_member/myroom/payment_list",
  MENU_PAYMENT_RESULT_LIST: "/pwa/campparent_member/myroom/payment_result_list",
  MENU_PAYMENT_ONLINE_LIST: "/pwa/campparent_member/myroom/payment_online_list",
  MENU_CHILD_STUDY_REPORT: "/pwa/campparent_member/child/child_study_report",
  SUB_PAYMENT_FINAL_LIST: "/pwa/campparent_member/myroom/payment_final_list",
  SUB_PAYMENT_RESULT_VIEW: "/pwa/campparent_member/myroom/payment_result_view",
  

  //test layout (이후에 삭제)
  TEST_LAYOUT_PAGE1: "/test-layout1",

  goPage(url, param, options) {
    var opt = {
      context: param,
      clearPreviousHistory: true,
    };

    if (options != undefined) {
      opt = Object.assign(options, opt);
    }

    f7.views.main.router.navigate(url, opt);
  },
  popPage(url, param, options) {
    var opt = {
      context: param,
      clearPreviousHistory: false,
    };

    if (options != undefined) {
      opt = Object.assign(options, opt);
    }

    this.resetReturnObj();
    f7.views.main.router.navigate(url, opt);
  },
  resetReturnObj() {
    f7.data.retObj = undefined;
  },
  setReturnObj(retObj) {
    f7.data.retObj = retObj;
  },
  getReturnObj() {
    return f7.data.retObj;
  },
  back(url, options) {
    f7.views.main.router.back(url, options);
  },
  updatePage(url) {
    f7.views.main.router.updateCurrentUrl(url);
  },
  login(options) {
    this.goPage(this.LOGIN_PAGE, options);
  },
  config(options) {
    this.goPage(this.CONFIG_PAGE, options);
  },
  editStudent(passWord, options) {
    var url = this.EDIT_STUDENT_PAGE + "/" + passWord;
    this.popPage(url, options);
  },
  editTeacher(passWord, options) {
    var url = this.EDIT_TEACHER_PAGE + "/" + passWord;
    this.popPage(url, options);
  },
};

export default PAGES;
